'use strict';

module.exports = function toDiastereotopicSVG() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$width = options.width,
        width = _options$width === undefined ? 300 : _options$width,
        _options$height = options.height,
        height = _options$height === undefined ? 200 : _options$height,
        _options$prefix = options.prefix,
        prefix = _options$prefix === undefined ? 'ocl' : _options$prefix;

    var svg = options.svg;
    var diaIDs = this.getDiastereotopicAtomIDs();
    if (!svg) svg = this.toSVG(width, height, prefix);

    svg = svg.replace(/Atom:[0-9]+\"/g, function (value) {
        var atom = value.replace(/[^0-9]/g, '');
        return value + ' data-atomid="' + diaIDs[atom] + '"';
    });

    return svg;
};


//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/lib/extend/toDiastereotopicSVG.js
// module id = 54
// module chunks = 0